if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        if (!this.classList.contains('mayura-product-modal--mobile-gallery')) return;

        this.addEventListener('pointerup', (event) => {
          if (this.isMobileGallery() && event.pointerType === 'mouse') event.stopImmediatePropagation();
        }, true);

        this.querySelectorAll('[data-modal-step]').forEach((button) => {
          button.addEventListener('click', () => this.stepMedia(Number(button.dataset.modalStep)));
        });
        this.querySelectorAll('[data-modal-media-id]').forEach((button) => {
          button.addEventListener('click', () => this.setActiveMedia(button.dataset.modalMediaId));
        });
        this.addEventListener('keydown', (event) => {
          if (!this.isMobileGallery() || !this.hasAttribute('open')) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.stepMedia(event.key === 'ArrowLeft' ? -1 : 1);
          }
        });

        const content = this.querySelector('.product-media-modal__content');
        content.addEventListener('touchstart', (event) => {
          if (!this.isMobileGallery() || this.modalAnimation) return;
          if (event.touches.length !== 1) {
            this.touchStart = null;
            this.resetMobileDrag();
            return;
          }
          this.touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY, axis: null };
        }, { passive: true });
        content.addEventListener('touchmove', (event) => {
          if (!this.touchStart || !this.isMobileGallery()) return;
          if (event.touches.length !== 1) {
            this.touchStart = null;
            this.resetMobileDrag();
            return;
          }
          const dx = event.touches[0].clientX - this.touchStart.x;
          const dy = event.touches[0].clientY - this.touchStart.y;
          if (!this.touchStart.axis) this.touchStart.axis = this.getSwipeAxis(dx, dy);
          if (!this.touchStart.axis) return;
          const active = content.querySelector('.active');
          if (active?.tagName !== 'IMG') return;
          event.preventDefault();
          if (this.touchStart.axis === 'vertical') {
            active.style.transform = `translateY(${dy}px)`;
            active.style.opacity = Math.max(0.72, 1 - Math.abs(dy) / 900);
            return;
          }
          const next = this.getAdjacentMedia(dx < 0 ? 1 : -1);
          const offset = next ? dx : dx * 0.25;
          active.style.transform = `translateX(${offset}px)`;
          if (next?.tagName === 'IMG') {
            this.clearMobilePreview(next);
            next.classList.add('mayura-modal-preview');
            next.style.transform = `translateX(${offset + (dx < 0 ? 1 : -1) * content.clientWidth}px)`;
          }
        }, { passive: false });
        content.addEventListener('touchend', (event) => {
          if (!this.touchStart || !this.isMobileGallery() || event.changedTouches.length !== 1) return;
          const distanceX = event.changedTouches[0].clientX - this.touchStart.x;
          const distanceY = event.changedTouches[0].clientY - this.touchStart.y;
          const axis = this.touchStart.axis || this.getSwipeAxis(distanceX, distanceY);
          this.touchStart = null;
          if (axis === 'horizontal' && Math.abs(distanceX) > 55 && this.getAdjacentMedia(distanceX < 0 ? 1 : -1)) {
            this.stepMedia(distanceX < 0 ? 1 : -1, distanceX);
          } else if (axis === 'vertical' && Math.abs(distanceY) > 100) {
            this.animateMobileClose(distanceY);
          } else {
            this.settleMobileDrag();
          }
        }, { passive: true });
        content.addEventListener('touchcancel', () => {
          this.touchStart = null;
          this.settleMobileDrag();
        });
      }

      isMobileGallery() {
        return this.classList.contains('mayura-product-modal--mobile-gallery') && window.matchMedia('(max-width: 749px)').matches;
      }

      getSwipeAxis(dx, dy) {
        const horizontal = Math.abs(dx);
        const vertical = Math.abs(dy);
        if (horizontal >= 18 && horizontal >= vertical * 1.25) return 'horizontal';
        if (vertical >= 28 && vertical >= horizontal * 1.6) return 'vertical';
        return null;
      }

      hide() {
        this.touchStart = null;
        this.clearMobileAnimation();
        this.resetMobileDrag();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.setActiveMedia(this.openedBy.getAttribute('data-media-id'), false);
      }

      getAdjacentMedia(direction) {
        const media = Array.from(this.querySelector('[role="document"]').children).filter((element) => element.hasAttribute('data-media-id'));
        const currentIndex = media.findIndex((element) => element.classList.contains('active'));
        return media[currentIndex + direction];
      }

      stepMedia(direction, startX = 0) {
        const nextMedia = this.getAdjacentMedia(direction);
        if (nextMedia) this.setActiveMedia(nextMedia.dataset.mediaId, true, startX);
      }

      setActiveMedia(mediaId, animate = true, startX = 0) {
        const container = this.querySelector('[role="document"]');
        const media = Array.from(container.children).filter((element) => element.hasAttribute('data-media-id'));
        const activeMedia = media.find((element) => element.dataset.mediaId === mediaId);
        if (!activeMedia) return;
        const previousMedia = media.find((element) => element.classList.contains('active'));
        if (animate && this.isMobileGallery() && !this.modalAnimation &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
          previousMedia?.tagName === 'IMG' && activeMedia.tagName === 'IMG' && previousMedia !== activeMedia) {
          this.animateMobileSwitch(previousMedia, activeMedia, media.indexOf(activeMedia) > media.indexOf(previousMedia) ? 1 : -1, startX);
          return;
        }
        this.clearMobileAnimation();
        this.resetMobileDrag();
        if (this.isMobileGallery()) window.pauseAllMedia();
        media.forEach((element) => element.classList.toggle('active', element === activeMedia));
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (this.isMobileGallery()) {
          const activeIndex = media.indexOf(activeMedia);
          const current = this.querySelector('[data-modal-current]');
          if (current) current.textContent = activeIndex + 1;
          this.querySelectorAll('[data-modal-step]').forEach((button) => {
            button.disabled = Number(button.dataset.modalStep) < 0 ? activeIndex === 0 : activeIndex === media.length - 1;
          });
          this.querySelectorAll('[data-modal-media-id]').forEach((button) => {
            const selected = button.dataset.modalMediaId === mediaId;
            button.setAttribute('aria-current', selected ? 'true' : 'false');
            if (selected) button.scrollIntoView({ block: 'nearest', inline: 'center' });
          });
        } else {
          activeMedia.scrollIntoView();
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      animateMobileSwitch(previous, next, direction, startX) {
        const container = this.querySelector('[role="document"]');
        const distance = container.clientWidth;
        next.classList.add('mayura-modal-preview');
        const previousStartTransform = previous.style.transform || `translateX(${startX}px)`;
        const nextStartTransform = next.style.transform || `translateX(${startX + direction * distance}px)`;
        const timing = { duration: 300, easing: 'cubic-bezier(.2,.72,.2,1)', fill: 'forwards' };
        const outgoing = previous.animate([
          { transform: previousStartTransform, opacity: Number(previous.style.opacity) || 1 },
          { transform: `translateX(${-direction * distance}px)`, opacity: 0.94 },
        ], timing);
        const incoming = next.animate([
          { transform: nextStartTransform, opacity: Number(next.style.opacity) || 0.94 },
          { transform: 'translateX(0)', opacity: 1 },
        ], timing);
        this.modalAnimation = [outgoing, incoming];
        incoming.finished.then(() => {
          if (this.modalAnimation?.[1] !== incoming) return;
          previous.style.transform = `translateX(${-direction * distance}px)`;
          previous.style.opacity = '0.94';
          next.style.transform = 'translateX(0)';
          next.style.opacity = '1';
          this.clearMobileAnimation();
          this.setActiveMedia(next.dataset.mediaId, false);
        }).catch(() => {});
      }

      animateMobileClose(distanceY) {
        const active = this.querySelector('[role="document"] .active');
        if (active?.tagName !== 'IMG' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.hide();
          return;
        }
        const animation = active.animate([
          { transform: `translateY(${distanceY}px)`, opacity: Number(active.style.opacity) || 1 },
          { transform: `translateY(${distanceY > 0 ? 110 : -110}vh)`, opacity: 0 },
        ], { duration: 230, easing: 'ease-out', fill: 'forwards' });
        this.modalAnimation = [animation];
        animation.finished.then(() => {
          if (this.modalAnimation?.[0] === animation) this.hide();
        }).catch(() => {});
      }

      clearMobilePreview(keep) {
        this.querySelectorAll('.mayura-modal-preview').forEach((element) => {
          if (element === keep) return;
          element.classList.remove('mayura-modal-preview');
          element.style.transform = '';
        });
      }

      clearMobileAnimation() {
        this.modalAnimation?.forEach((animation) => animation.cancel());
        this.modalAnimation = null;
      }

      settleMobileDrag() {
        const active = this.querySelector('[role="document"] .active');
        if (!active?.style.transform || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.resetMobileDrag();
          return;
        }
        const preview = this.querySelector('.mayura-modal-preview');
        const timing = { duration: 220, easing: 'cubic-bezier(.2,.72,.2,1)', fill: 'forwards' };
        const animations = [active.animate([
          { transform: active.style.transform, opacity: Number(active.style.opacity) || 1 },
          { transform: 'translate(0)', opacity: 1 },
        ], timing)];
        if (preview) {
          const direction = preview.style.transform.includes('translateX(-') ? -1 : 1;
          animations.push(preview.animate([
            { transform: preview.style.transform },
            { transform: `translateX(${direction * this.querySelector('[role="document"]').clientWidth}px)` },
          ], timing));
        }
        this.modalAnimation = animations;
        animations[0].finished.then(() => {
          if (this.modalAnimation?.[0] !== animations[0]) return;
          this.clearMobileAnimation();
          this.resetMobileDrag();
        }).catch(() => {});
      }

      resetMobileDrag() {
        this.querySelectorAll('[role="document"] .active, .mayura-modal-preview').forEach((element) => {
          element.style.transform = '';
          element.style.opacity = '';
          element.classList.remove('mayura-modal-preview');
        });
      }
    }
  );
}
